import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-finanzas',
  templateUrl: './finanzas.component.html',
  styleUrls: ['./finanzas.component.css']
})
export class FinanzasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
